module.exports = ".align-buttons {\n  text-align: right; }\n\n.link {\n  text-decoration: underline;\n  color: #00215a; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-forklift/master-maintenance-forklift.component.scss
// module id = ./src/app/master/master-maintenance-forklift/master-maintenance-forklift.component.scss
// module chunks = main